export interface OrganizationProgressDonutProps {
  complete: number;
  total: number;
  size?: number;
}

export function OrganizationProgressDonut({
  complete,
  total,
  size = 26,
}: OrganizationProgressDonutProps) {
  const stroke = 2.5;
  const radius = 10;
  const circumference = 2 * Math.PI * radius;
  const progress = total > 0 ? Math.min(1, Math.max(0, complete / total)) : 0;
  const dashOffset = circumference * (1 - progress);

  return (
    <span
      className="inline-flex shrink-0 text-(--fg-brand)"
      aria-hidden
      style={{ width: size, height: size }}
    >
      <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24">
        <g transform="rotate(-90 12 12)">
          <circle
            cx="12"
            cy="12"
            r={radius}
            fill="none"
            stroke="currentColor"
            strokeOpacity="0.18"
            strokeWidth={stroke}
          />
          <circle
            cx="12"
            cy="12"
            r={radius}
            fill="none"
            stroke="currentColor"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            style={{
              transition:
                "stroke-dashoffset 240ms cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          />
        </g>
      </svg>
    </span>
  );
}
